import React from 'react'
import BlogImg from "../assets/img/blog/01.jpg"
import { Link } from 'react-router-dom'

function FullBlogArea() {
  return (
    <div class="blog-area py-120">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 mx-auto">
                <div class="site-heading text-center">
                    <span class="site-title-tagline"><i class="flaticon-delivery-truck"></i> Serviswift Blog</span>
                    <h2 class="site-title">Latest Updates & Insights</h2>
                    <div class="heading-divider"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <div class="blog-item wow fadeInUp" data-wow-delay=".25s">
                    <div class="blog-item-img">
                        <img src={BlogImg} alt="Serviswift Update 1"/>
                    </div>
                    <div class="blog-item-info">
                        <div class="blog-item-meta">
                            <ul>
                                <li><Link href="/blog"><i class="far fa-user-circle"></i> By John Doe</Link></li>
                                <li><Link href="/blog"><i class="far fa-calendar-alt"></i> January 5, 2025</Link></li>
                            </ul>
                        </div>
                        <h4 class="blog-title">
                            <Link href="/blog">How Serviswift is Redefining Delivery Services.</Link>
                        </h4>
                        <Link class="theme-btn" href="/blog">Read More<i class="fas fa-arrow-right"></i></Link>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="blog-item wow fadeInUp" data-wow-delay=".50s">
                    <div class="blog-item-img">
                        <img src={BlogImg} alt="Serviswift Update 2"/>
                    </div>
                    <div class="blog-item-info">
                        <div class="blog-item-meta">
                            <ul>
                                <li><Link href="/blog"><i class="far fa-user-circle"></i> By Jane Smith</Link></li>
                                <li><Link href="/blog"><i class="far fa-calendar-alt"></i> January 12, 2025</Link></li>
                            </ul>
                        </div>
                        <h4 class="blog-title">
                            <Link href="/blog">Tips for Optimizing Your Delivery Routes.</Link>
                        </h4>
                        <Link class="theme-btn" href="/blog">Read More<i class="fas fa-arrow-right"></i></Link>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <div class="blog-item wow fadeInUp" data-wow-delay=".75s">
                    <div class="blog-item-img">
                        <img src={BlogImg} alt="Serviswift Update 3"/>
                    </div>
                    <div class="blog-item-info">
                        <div class="blog-item-meta">
                            <ul>
                                <li><Link href="/blog"><i class="far fa-user-circle"></i> By Sarah Lee</Link></li>
                                <li><Link href="/blog"><i class="far fa-calendar-alt"></i> January 18, 2025</Link></li>
                            </ul>
                        </div>
                        <h4 class="blog-title">
                            <Link href="/blog">Why Efficient Logistics Matter in 2025.</Link>
                        </h4>
                        <Link class="theme-btn" href="/blog">Read More<i class="fas fa-arrow-right"></i></Link>
                    </div>
                </div>
            </div>
        </div>

        <div class="pagination-area">
            <div aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item">
                        <Link class="page-link" href="/blog" aria-label="Previous">
                            <span aria-hidden="true"><i class="far fa-arrow-left"></i></span>
                        </Link>
                    </li>
                    <li class="page-item active"><Link class="page-link" href="/blog">1</Link></li>
                    <li class="page-item"><Link class="page-link" href="/blog">2</Link></li>
                    <li class="page-item"><Link class="page-link" href="/blog">3</Link></li>
                    <li class="page-item">
                        <Link class="page-link" href="/blog" aria-label="Next">
                            <span aria-hidden="true"><i class="far fa-arrow-right"></i></span>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

  )
}

export default FullBlogArea